import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FileAddEditView from 'components/pages/FileAddEdit';

import {
  onDownload,
  onFileUnload,
  onFileUpload,
  onSubmit,
  onCancel,
  loadPageData,
} from './store';

class FileAddEditContainer extends React.Component {
  static propTypes = {
    isLoadedPage: PropTypes.bool.isRequired,
    loadPageData: PropTypes.func.isRequired,
    modalProps: PropTypes.objectOf(PropTypes.any).isRequired,
    onCancel: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    onFileUnload: PropTypes.func.isRequired,
    onFileUpload: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { patientId, id } = this.props.modalProps;
    this.props.loadPageData(patientId, id);
  }

  render() {
    return this.props.isLoadedPage ? (
      <FileAddEditView {...this.props} />
    ) : null;
  }
}

const mapDispatchToProps = {
  onDownload,
  onFileUnload,
  onFileUpload,
  onSubmit,
  onCancel,
  loadPageData,
};

const mapStateToProps = (state) => ({
  ...state.FileAddEdit,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FileAddEditContainer);
